import { render } from "./ClientRow.vue?vue&type=template&id=f9927178&scoped=true"
import script from "./ClientRow.vue?vue&type=script&lang=js"
export * from "./ClientRow.vue?vue&type=script&lang=js"

import "./ClientRow.vue?vue&type=style&index=0&id=f9927178&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9927178"]])

export default __exports__